import { registerSmarticoProfileEventHandler } from '~/handlers/register-smartico-profile-event';
import type { SmarticoProfilePayload } from '~/handlers/ports/api-smartico-profile-event.port';
import { NativeEvent } from '~/shared/NativeBridge/NativeEvent';
import { SmarticoProfileEvent } from '~/shared/smartico/smartico-profile-event';
import { isRunningInIosNativeApp } from '~/utils/browserInfo';

export const useSmarticoProfileEvent = () => {
  const { userId } = useUserData();

  // Chamado pelo `setAuth` da store de auth, por onde passa TODA autenticacao
  // (login, 2FA, biometria, cadastro, verificacao de e-mail, `loginSuccess` do
  // iframe). Ficava so nos tres componentes de login, e por isso quem se
  // cadastrava pelo app so ganhava a prop no primeiro login explicito depois
  // disso — em producao, 31% das contas mais novas estavam sem ela.
  //
  // Sem guarda local de propósito: o `localStorage` do WebView do app e o do
  // navegador sao areas separadas, entao ele so sabe o que AQUELE dispositivo
  // mandou, nunca o que o perfil tem. Quem alterna app e navegador voltaria ao
  // site sem que a prop6 voltasse para WEB. A supressao de reenvio vive no
  // core, que guarda o ultimo valor confirmado POR JOGADOR.
  const sendAuthEvent = async (): Promise<void> => {
    const userExtId = String(userId.value || '');

    if (!userExtId) return;

    const isNativeApp = NativeEvent.isNativeApp();

    // Plataforma via deteccao local (user-agent + bridge), NAO via atribuicao
    // AppsFlyer: o recado `appsflyerUid` da bridge e suprimido quando o
    // usuario nega o ATT (iOS), o que deixava `journeyStore.appsflyer.platform`
    // vazio e silenciava este evento para praticamente todo iOS.
    const platform = isNativeApp
      ? isRunningInIosNativeApp()
        ? 'IOS'
        : 'ANDROID'
      : 'WEB';

    // A prop6 marca a origem de toda entrada; a prop25 so existe dentro do app
    // e NAO viaja na web — manda-la vazia apagaria a plataforma de app de quem
    // usa os dois.
    const payload: SmarticoProfilePayload = { core_custom_prop6: platform };

    if (isNativeApp) payload.core_custom_prop25 = platform;

    try {
      await registerSmarticoProfileEventHandler({
        event: SmarticoProfileEvent.UpdateProfile,
        user_ext_id: userExtId,
        payload,
      });
    } catch (e) {
      console.error('[smartico-profile-event] failed', e);
    }
  };

  return { sendAuthEvent };
};
